"use client"

import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react"
import * as React from "react"
import { DayPicker } from "react-day-picker"
import "react-day-picker/style.css"
import { cn } from "../../utils"

function Calendar({ className, classNames, showOutsideDays = true, ...props }: React.ComponentProps<typeof DayPicker>) {
	return (
		<DayPicker
			showOutsideDays={showOutsideDays}
			fixedWeeks={true}
			navLayout="around"
			className={className}
			classNames={{
				months: "flex flex-col sm:flex-row gap-2",
				month: "flex flex-col gap-4",
				month_caption: "flex justify-center items-center mx-(--rdp-nav_button-width)",
				caption_label: "text-lg font-bold",
				nav: "flex items-center gap-1",
				button_previous: "VIconButton small white absolute left-0",
				button_next: "VIconButton small white absolute right-0",
				month_grid: "w-full border-collapse space-x-1",
				weekdays: "flex [&>th:first-child]:text-error",
				weekday: "flex items-center justify-center size-9 font-bold text-xs",
				week: "flex w-full mt-2 [&>td:first-child]:text-error [&>td:first-child_.day-outside]:text-error/50",
				day: "relative p-0 text-center text-sm font-bold rounded-full transition-colors",
				day_button: "size-9 rounded-full hover:bg-g800/20 cursor-pointer transition-colors",
				selected: "bg-primary text-black border-0 rounded-full",
				today: "bg-g0 rounded-full",
				outside: "day-outside text-text-placeholder aria-selected:!text-primary-foreground",
				disabled: "opacity-20 hover:bg-transparent !cursor-not-allowed",
				range_start:
					"day-range-start aria-selected:bg-primary aria-selected:text-black aria-selected:rounded-l-full aria-selected:rounded-r-none aria-selected:[&.day-range-end]:!rounded-r-full",
				range_end:
					"day-range-end aria-selected:bg-primary aria-selected:text-black aria-selected:rounded-r-full aria-selected:rounded-l-none aria-selected:[&.day-range-start]:!rounded-l-full",
				range_middle: "aria-selected:bg-primary aria-selected:text-black aria-selected:rounded-none",
				hidden: "invisible",
				...classNames
			}}
			components={{
				Chevron: ({ className, ...props }) => {
					if (props.orientation === "left") {
						return <ChevronLeftIcon className={cn("size-4", className)} {...props} />
					}
					return <ChevronRightIcon className={cn("size-4", className)} {...props} />
				}
			}}
			{...props}
		/>
	)
}

export { Calendar }
